import { z } from 'zod';

const BOUNDING_BOX = z.object({
  left: z.number(),
  top: z.number(),
  right: z.number(),
  bottom: z.number(),
  anchor_point: z.string(),
});
export type BoundingBox = z.infer<typeof BOUNDING_BOX>;

const DATA_CHUNK_SCHEMA = z.object({
  text: z.string(),
  reference_id: z.string(),
  wordcount: z.number(),
});

const METADATA_SCHEMA = z.object({
  itemsMetadata: z.array(
    z.object({
      reference_id: z.string(),
      bounding_box: BOUNDING_BOX,
    })
  ),
  page_number: z.number(),
});

export const DATA_CHUNKS_RESPONSE_ENTRY_SCHEMA = z.object({
  data: z.array(DATA_CHUNK_SCHEMA),
  metadata: METADATA_SCHEMA.nullable(),
});
export type DataChunksResponseEntry = z.infer<typeof DATA_CHUNKS_RESPONSE_ENTRY_SCHEMA>;
